// ======================================================================
// File Name       : FormField
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import MessageValidate from '../MessageValidate';
import { ERROR_TYPE } from '../../constants';

const formatMessage = (msg, label) => msg.replace('{0}', label);

const FormField = ({ input, label, type, meta: { active, touched, error, warning } }) => {
  const formatedMsg = formatMessage(error || warning || '', label);

  return (
    <div>
      <input {...input} type={type} className="form-control" />
      <MessageValidate
        errorType={error ? ERROR_TYPE.ERROR : ERROR_TYPE.SUCCESS}
        visible={touched && error}
        errorMessage={formatedMsg}
      />
    </div>
  );
};

const makeInput = (input, firstAddon, afterAddon) =>
  firstAddon || afterAddon
    ? <div className="input-group">
      {firstAddon &&
      <span className="input-group-text">
        {firstAddon}
      </span>}
      {input}
      {afterAddon &&
      <span className="input-group-text" style={{ fontSize: '14px' }}>
        {afterAddon}
      </span>}
    </div>
    : input;

const ValidationField = ({
  input,
  type,
  indent,
  label,
  labelSecond,
  labelRequired,
  labelSize = 4,
  inputSize = 8,
  maxLength,
  options = [],
  firstAddon,
  afterAddon,
  clearTouch,
  meta: { active, touched, error, warning },
  disabled, /* #7182 */
  hidden, // Step 12.0.0 TAS-18710
}) => {
  const formatedMsg = formatMessage(error || warning || '', label);
  const paddingLeft = indent && indent > 0 && `${15 * indent}px`;
  const labelSecondSize = 2;

  let inputComp;
  if (type === 'select') {
    inputComp = makeInput(
      <select {...input} className="form-select" disabled={disabled}>
        {options.map((opt, index) =>
          (<option key={opt.value} value={opt.value}>
            {opt.name}
          </option>),
        )}
      </select>,
      firstAddon,
      afterAddon,
    );
  } else {
    inputComp = makeInput(
      <input
        {...input}
        type={type}
        maxLength={maxLength}
        className="form-control"
        onFocus={() => {
          if (clearTouch) {
            clearTouch();
          }
        }}
        disabled={disabled} /* #7182 */
      />,
      firstAddon,
      afterAddon,
    );
  }

  if (hidden) return null; // Step 12.0.0 TAS-18710

  return (
    <Form.Group className="form-info">
      <Col as={Form.Label} sm={labelSize} className="text-nowrap">
        <div style={{ paddingLeft }}>
          {label} {labelRequired && <span className="required">&nbsp;(※)</span>}
        </div>
      </Col>
      {labelSecond &&
        <Col as={Form.Label} sm={labelSecondSize} className="padding-left-right-15">
          <div>
            {labelSecond}
          </div>
        </Col>}
      <Col sm={labelSecond ? inputSize - labelSecondSize : inputSize} className="padding-left-right-15">
        {inputComp}
        <MessageValidate
          errorType={error ? ERROR_TYPE.ERROR : ERROR_TYPE.SUCCESS}
          visible={touched && (error || warning)}
          errorMessage={formatedMsg}
        />
      </Col>
    </Form.Group>
  );
};

export { FormField as default, ValidationField };
